import {
  Box,
  Button,
  Card,
  CardContent,
  Chip,
  Collapse,
  Grid,
  Hidden,
  IconButton,
  Tooltip,
  Typography,
} from "@mui/material";

//... Icons imports
import AddCircleOutlinedIcon from "@mui/icons-material/AddCircleOutlined";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import VisibilityIcon from "@mui/icons-material/Visibility";
import EditIcon from "@mui/icons-material/Edit";
import AddCircleIcon from "@mui/icons-material/AddCircle";

//... Child Component imports
import PlayerList from "../participation/PlayerList";

const ParticipantsSection = ({
  classes,
  handleToggle,
  activeView,
  showParticipants,
  toggleParticipants,
  addParticipant,
  searchPlayerOrCollegeName,
  playerNameSearchText,
  playerData,
  participants,
  commonEventList,
  eventRosterID,
  setEventRosterID,
  eventDetails,
  setParticipants,
  editMode,
  loading,
  handleOnSaveAction,
  handleSelectAllParticipant,
}) => {
  return (
    <Grid item lg={12} md={12} sm={12} xs={12}>
      <Card sx={{ backgroundColor: "#E6E6FA" }}>
        <CardContent>
          <Grid container alignItems="center" mb={1}>
            <Grid item lg={8} md={8} sm={6} xs={6}>
              <Typography variant="subtitle2" component="label">
                Participants:
              </Typography>
            </Grid>
            <Grid item lg={4} md={4} sm={6} xs={6}>
              <Grid container alignItems="center" justifyContent="flex-end">
                <Grid item>
                  <Button
                    variant="contained"
                    color="primary"
                    loading={loading}
                    loadingPosition="end"
                    onClick={() =>
                      handleOnSaveAction(eventDetails.eventId || 0)
                    }
                    disabled={loading}
                  >
                    <Hidden smDown>Save</Hidden>
                  </Button>
                </Grid>
                <Grid item>
                  <Tooltip title="Add Participants">
                    <IconButton
                      onClick={() => handleToggle("participantsList")}
                      className={classes.iconButton}
                      disabled={
                        activeView === "participantsList" || !showParticipants
                      }
                    >
                      <AddCircleOutlinedIcon
                        color={
                          activeView !== "participantsList" && showParticipants
                            ? "primary"
                            : "inherit"
                        }
                        fontSize="small"
                      />
                    </IconButton>
                  </Tooltip>
                </Grid>
                <Grid item>
                  <Tooltip title="View Selected Participants">
                    <IconButton
                      onClick={() => handleToggle("participants")}
                      className={classes.iconButton}
                      disabled={
                        activeView === "participants" || !showParticipants
                      }
                    >
                      <VisibilityIcon
                        color={
                          activeView !== "participants" && showParticipants
                            ? "primary"
                            : "inherit"
                        }
                        fontSize="small"
                      />
                    </IconButton>
                  </Tooltip>
                </Grid>
                <Grid item>
                  <Tooltip
                    title={
                      showParticipants ? "Collapse Details" : "Expand Details"
                    }
                  >
                    <IconButton
                      onClick={toggleParticipants}
                      className={classes.iconButton}
                    >
                      {showParticipants ? (
                        <ExpandMoreIcon color="primary" fontSize="small" />
                      ) : (
                        <ExpandLessIcon color="primary" fontSize="small" />
                      )}
                    </IconButton>
                  </Tooltip>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Collapse in={showParticipants}>
            {activeView === "participantsList" ? (
              <PlayerList
                playerData={playerData}
                participants={participants}
                classes={classes}
                addParticipant={addParticipant}
                playerNameSearchText={playerNameSearchText}
                searchPlayerOrCollegeName={searchPlayerOrCollegeName}
                commonEventList={commonEventList}
                eventRosterID={eventRosterID}
                setEventRosterID={setEventRosterID}
                eventDetails={eventDetails}
                setParticipants={setParticipants}
                editMode={editMode}
                handleSelectAllParticipant={handleSelectAllParticipant}
              />
            ) : (
              <Box
                mt={2}
                sx={{
                  backgroundColor: "#fff",
                  borderRadius: "8px",
                  boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                  p: 3,
                }}
              >
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: "bold",
                    color: "#333",
                    mb: 2,
                    textTransform: "uppercase",
                    letterSpacing: "0.5px",
                    fontSize: "clamp(0.8rem, 2vw, 1rem)",
                  }}
                >
                  Selected Participants
                </Typography>
                {participants?.length === 0 ? (
                  <Typography sx={{ color: "#888", fontStyle: "italic" }}>
                    No participants selected
                  </Typography>
                ) : (
                  <Grid container spacing={1}>
                    {participants.map((participant, index) => (
                      <Grid item key={index}>
                        <Chip
                          label={participant.playerName}
                          color="primary"
                          variant="filled"
                          sx={{
                            fontSize: "14px",
                            borderRadius: "16px",
                            boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.2)",
                            "&:hover": {
                              backgroundColor: "#005a8f",
                            },
                          }}
                        />
                      </Grid>
                    ))}
                  </Grid>
                )}
              </Box>
            )}
          </Collapse>
        </CardContent>
      </Card>
    </Grid>
  );
};

export default ParticipantsSection;
